import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { withNamespaces } from "react-i18next";

import Spinner from "~/components/Spinner";
import pagination from "~/components/pagination/currentSizePerPage/10";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { PORTALRH_MIDDLEWARE } from "~/utils/constants";
import { useInterval } from "~/components/Notifications/utils/useInterval.js";

import {
  getRequestsByUsername,
  setGenericRequestState,
} from "~/store/ducks/portalrh/actionTypes";

import { Tabs, Tab } from "react-bootstrap";

import { RequestState } from "~/components/widgets/Requests/TabsEnum.js";

const PersonalAreaRequestTable = ({
  searchFilter,
  t,
  handleOpenFlowModal,
}) => {
  const { genericRequestState } = useSelector((state) => state.portalrhReducer);

  const { user } = useSelector((state) => state.globalReducer);

  const dispatch = useDispatch();
  const usernamePortalRh = user.legacyUsers.find(
    (item) => item.legacyApplication.label === PORTALRH_MIDDLEWARE.context
  ).username;
  const { requests, isLoadingRequests } = useSelector(
    (state) => state.portalrhReducer
  );

  useEffect(() => {
    dispatch(getRequestsByUsername(usernamePortalRh,1));
  }, []);

  useInterval(() => {
    dispatch(getRequestsByUsername(usernamePortalRh,1));
  }, 1000 * 60);

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "id",
      text: t("portalrh.requestTable.requestId"),
      sort: true,
    },
    {
      dataField: "auth_designation",
      text: t("portalrh.requestTable.description"),
      sort: true,
    },
    {
      dataField: "creation_date",
      text: t("portalrh.requestTable.date"),
      sort: true,
    },
    {
      dataField: "change_type",
      text: t("portalrh.requestTable.type"),
      sort: true,
    },
    {
      dataField: "state",
      text: t("portalrh.requestTable.state"),
      sort: true,
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      e.stopPropagation();
      e.preventDefault();
      handleOpenFlowModal(row);
    },
  };

  return (
    <>
      <div className="custom-table custom-table-small">
        <ToolkitProvider
          keyField="id"
          data={requests
            .filter(
              (request) =>
                request.state === genericRequestState &&
                request.description === searchFilter &&
                request.authorizer_approves === -1
            )
            .sort(function (a, b) {
              if (a.id > b.id) {
                return -1;
              }
              if (a.id < b.id) {
                return 1;
              }
              // a must be equal to b
              return 0;
            })}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div style={{ paddingBottom: "20px", display: "flex" }}>
                <SearchBar {...props.searchProps} placeholder={t("Search")} />
              </div>

              <Tabs
                id="authorizationTabs"
                defaultActiveKey={genericRequestState}
                className="custom-tabs"
                activeKey={genericRequestState}
                onSelect={(k) => dispatch(setGenericRequestState(k))}
              >
                <Tab
                  eventKey={RequestState.PENDING}
                  title={t("portalrh.requests.pendingRequests")}
                ></Tab>
                <Tab
                  eventKey={RequestState.APPROVED}
                  title={t("portalrh.requests.approvedRequests")}
                ></Tab>
                <Tab
                  eventKey={RequestState.REJECTED}
                  title={t("portalrh.requests.refusedRequests")}
                ></Tab>
              </Tabs>

              <Spinner spinning={isLoadingRequests} />
              {!isLoadingRequests && (
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4
                  pagination={paginationFactory(pagination)}
                  noDataIndication={t("No personal requests available")}
                  rowEvents={rowEvents}
                  striped
                  hover
                />
              )}
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};
export default withNamespaces()(PersonalAreaRequestTable);
